import { render, staticRenderFns } from "./MonthlyTurnover.vue?vue&type=template&id=63f688e2&scoped=true"
import script from "./MonthlyTurnover.vue?vue&type=script&lang=ts"
export * from "./MonthlyTurnover.vue?vue&type=script&lang=ts"
import style0 from "./MonthlyTurnover.vue?vue&type=style&index=0&id=63f688e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f688e2",
  null
  
)

export default component.exports